import { Text, Container, colors } from "@carrotfertility/carotene"
import React from "react"
import { getPiiProps } from "services/tracking"

export const LocationMenuItem = React.forwardRef(
  (
    {
      description,
      matchedSubstrings,
      ...props
    }: React.PropsWithChildren<{ description: string; matchedSubstrings: any[] }>,
    ref: React.RefObject<HTMLDivElement>
  ) => {
    const matchedSubstringDetails = matchedSubstrings[0]
    const { length, offset } = matchedSubstringDetails || { length: 0, offset: 0 }
    const beforeMatchedSubstring = matchedSubstringDetails ? description.slice(0, offset) : description
    const matchedSubstring = matchedSubstringDetails ? description.slice(offset, offset + length) : ""
    const afterMatchedSubstring = matchedSubstringDetails ? description.slice(offset + length) : ""

    return (
      <div ref={ref}>
        <Container
          {...getPiiProps()}
          paddingTopBottom="tiny"
          paddingLeftRight="medium"
          minWidth="150px"
          sx={{
            ":hover": {
              cursor: "pointer"
            }
          }}
          {...props}
        >
          {beforeMatchedSubstring}
          <Text weight="bold">{matchedSubstring}</Text>
          {afterMatchedSubstring}
        </Container>
      </div>
    )
  }
)
LocationMenuItem.displayName = "LocationMenuItem"

export const LocationMenu = React.forwardRef(
  (
    { isOpen, ...props }: React.PropsWithChildren<{ isOpen: boolean }>,
    ref: React.RefObject<HTMLDivElement>
  ): JSX.Element => {
    const width = isOpen ? "100%" : "0"
    const height = isOpen ? null : "0"
    const padding = isOpen ? "8px 0px" : "0px"
    const display = isOpen ? null : "none"

    return (
      <div
        style={{
          zIndex: 4,
          border: `1px solid ${colors.base.black10}`,
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
          borderRadius: "8px",
          background: "white",
          position: "sticky",
          top: "70px",
          width: width,
          height: height,
          padding: padding,
          display: display
        }}
        ref={ref}
        {...props}
      />
    )
  }
)
LocationMenu.displayName = "LocationMenu"
